module.exports = __webpack_public_path__ + "static/media/20240530085330_IMG_7477.6d257188.JPG";